import React from 'react'
import { startCase } from 'lodash'
import { useSocketOperation } from 'socket.io-react'
import { observer } from '~/ui/component'
import { Label, ProgressBar, VBox } from '~/ui/components'
import { useForm } from '~/ui/form'
import { useResourceTranslation } from '~/ui/resources'
import { createUseStyles, layout } from '~/ui/styling'
import DuplicateProjectFormModel from './DuplicateProjectFormModel'
import DuplicateProjectResultList from './DuplicateProjectResultList'

export interface Props {}

const DuplicateStep = observer('DuplicateStep', (props: Props) => {

  const {model: formModel} = useForm<DuplicateProjectFormModel>()

  const [progress, labelKey, modelName, caption] = useSocketOperation(formModel.operation)
  const results = formModel.results

  const {t} = useResourceTranslation()

  const label = labelKey == null ? '' : t(`actions.duplicate.progress.${labelKey}`, {
    model:   modelName == null ? null : startCase(modelName).toLowerCase(),
    caption: caption,
  })

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <VBox classNames={$.DuplicateStep} flex='grow'>
        {results == null && renderProgress()}
        {results != null && renderResults()}
      </VBox>
    )
  }

  function renderProgress() {
    return (
      <VBox flex='grow' justify='middle' gap={layout.padding.s}>
        <ProgressBar
          progress={progress}
        />
        <Label align='center' small dim markup>
          {label}
        </Label>
      </VBox>
    )
  }

  function renderResults() {
    return (
      <DuplicateProjectResultList/>
    )

  }

  return render()

})

export default DuplicateStep

const useStyles = createUseStyles({
  DuplicateStep: {
    minHeight: 360,
  },

  copyButton: {
    minWidth: 320,
  },
})